import React from "react";
import style from "../../css/payment/Paymentcard.module.css";
import { Link } from "react-router-dom";

const PaymentCard = () => {
  return (
    <div className="d-flex justify-content-center py-4">

      <div className={style.cardContainer}>
        <div className={style.popularTag}>
          Most Popular <span className={style.starIcon}><i className="fa-solid fa-star"></i></span>
        </div>
        <h2 className={style.title}>SWING TRADING</h2>
        <p className={style.subtitle}>A JOURNEY WORTH TAKING!!!</p>
        <hr className={style.divider} />
        <h3 className={style.sectionTitle}>OUR Service's</h3>
        <div className={style.service_heading}><i className={`fa-solid fa-hashtag ${style.checkicons_hash}`}> </i> PREMIUM SWING SETUPS</div>
        <div className={style.PaymentCard_servicesrow}>
          <ul className={style.serviceList}>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> VCP setup</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> ROCKET BASE setup</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> IPO base setup</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> FNO setup</li>
          </ul>
          <div className={style.service_heading}><i className={`fa-solid fa-hashtag ${style.checkicons_hash}`}> </i> AI FUNDAMENTAL ANALYSIS</div>
          <ul className={style.serviceList}>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> COMPANY ANALYSIS</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> CORP FILLING</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> ANNUAL REPORTS</li>
          </ul>
          <div className={style.service_heading}><i className={`fa-solid fa-hashtag ${style.checkicons_hash}`}> </i> ALGOED SCANNER</div>
          <ul className={style.serviceList}>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> READY TO TRADE STOCKS</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> CHANCE TO JOIN Xploder GROUP - Mission 4000 community</li>
          </ul>

        </div>
        <div className={style.priceSection}>
          <p className={style.priceTitle}>Price</p>
          <p className={style.price}>
            3000 <i className="fa-solid fa-indian-rupee-sign"></i> <span className={style.priceDuration}>for 3 months</span>
          </p>
        </div>
        <div className={style.salestags}>
          <div className={style.saleTag}>SUPER</div>
          <div className={style.saleTag2}>SALE</div>
              <Link to={"/Reg_pay"} >
          <button className={style.buyButton} >BUY NOWWWWW</button>
              </Link>

        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
